import Slide1 from "../../../pages/intro/slides/Slide1";
import Slide2 from "../../../pages/intro/slides/Slide2";
import Slide3 from "../../../pages/intro/slides/Slide3";
import Slide4 from "../../../pages/intro/slides/Slide4";
import Slide5 from "../../../pages/intro/slides/Slide5";

export const BOOK_POSTERS = [
  '/assets/intro/books/book1.jpg',
  '/assets/intro/books/book2.jpg',
  '/assets/intro/books/book3.jpg',
  '/assets/intro/books/book4.jpg',
  '/assets/intro/books/book5.jpg',
];

export const CARTOON_POSTERS = [
  '/assets/intro/cartoons/cartoon1.jpg', 
  '/assets/intro/cartoons/cartoon2.jpg', 
  '/assets/intro/cartoons/cartoon3.jpg', 
  '/assets/intro/cartoons/cartoon4.jpg'
]

export const SLIDES = [
  {
    component: Slide1,
    color: '#09BCC1',
  },
  {
    component: Slide2,
    color: '#FACC15',
  },
  {
    component: Slide3,
    color: '#F97316',
  },
  {
    component: Slide4,
    color: '#8B5CF6',
  },
  {
    component: Slide5,
    color: '#EC4899',
  },
];